import React from 'react';

const IconSoftware = () => (
    <svg width="20px" height="20px" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
            <path fill="#626469" fillRule="nonzero" d="M7 0h23l13 13v37H7z" />
            <path fill="#333" fillRule="nonzero" d="M30 0l13 13H30z" />
            <path
                d="M27.447 36.226l.438 2.548a10.679 10.679 0 0 1-5.128.056l.09-2.606a8.056 8.056 0 0 1-3.188-1.836l-2.078 1.535A10.592 10.592 0 0 1 15 31.546l2.34-1.16a7.853 7.853 0 0 1-.214-1.8 8.05 8.05 0 0 1 .249-1.998l-2.371-1.022a10.525 10.525 0 0 1 2.59-4.388l2.087 1.528a8.14 8.14 0 0 1 3.366-1.875l-.436-2.514a10.695 10.695 0 0 1 5.044-.03l-.063 2.615a8.01 8.01 0 0 1 1.579.676 7.932 7.932 0 0 1 1.633 1.207l1.932-1.68a10.56 10.56 0 0 1 1.673 2.175c.453.778.795 1.59 1.03 2.418l-2.348 1.152a7.951 7.951 0 0 1-.048 3.615l2.412.888a10.537 10.537 0 0 1-2.578 4.512l-2.124-1.417c-.42.386-.897.72-1.395 1.011-.58.34-1.25.578-1.911.767zm1.903-7.669c0-2.222-1.846-4.022-4.123-4.022-2.276 0-4.123 1.8-4.123 4.022 0 2.221 1.847 4.022 4.123 4.022 2.277 0 4.123-1.8 4.123-4.022z"
                fill="#FFF"
            />
        </g>
    </svg>
);

export default IconSoftware;
